import axios from 'axios';

const BASE_URL = process.env.REACT_APP_API_URL;

export interface SchoolPublicData {
  nameofSchool: string;
  schoolCode: string;
  diseCode: string;
  district: string;
  pinNo: string;
  state: string;
  schoolPrincipalName: string;
  principalMobile: string;
  principalEmail: string;
  schoolLogo: string;
  schoolImage: string;
  domainName: string;
}

export async function fetchSchoolByDomain(domainName: string): Promise<SchoolPublicData> {
  const response = await axios.post<SchoolPublicData>(
    `${BASE_URL}/public/school-data?domainName=${encodeURIComponent(domainName)}`
  );
  return response.data;
}

export function getSchoolImageUrl(imageName: string): string {
  return `${BASE_URL}/public/image/${imageName}`;
}

export function getSchoolLogoUrl(logoName: string): string {
  return `${BASE_URL}/public/logo/${logoName}`;
}
